import { Ng2StateDeclaration, StatesModule, Transition } from '@uirouter/angular';
import { Statistic2NavigationTabsComponent } from '@fi-app/statistic2/statistic2-header/statistic2-navigation-tabs.component';
import { StateAccessCheckService } from '@fi-shared/fi-shared-services/state-access-check.service';
import { ApplicationSettingsType } from '@fi-shared/types/application-settings-type';
import { AccessRightType } from '@fi-shared/types/access-right-type';
import { Statistic2DashboardComponent } from '@fi-app/statistic2/statistic2-dashboard/statistic2-dashboard.component';
import { Statistic2ReportParameterListComponent } from '@fi-app/statistic2/statistic2-report-parameter-list/statistic2-report-parameter-list.component';
import { Statistic2ReportViewComponent } from '@fi-app/statistic2/statistic2-report-view/statistic2-report-view/statistic2-report-view.component';
import { FiAbstractStateComponent } from '@fi-shared/fi-state-proxy/fi-abstract-state.component';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { Statistic2Service } from '@fi-app/statistic2/statistic2.service';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { Statistic2ReportListComponent } from './statistic2-report-parameter-list/statistic2-report-list.component';

const Statistic2State: Ng2StateDeclaration = {
    name: FiStateNames.Statistic2._name,
    url: '/Statistic',
    abstract: true,
    component: Statistic2NavigationTabsComponent,
};

const Statistic2DashboardState: Ng2StateDeclaration = {
    name: FiStateNames.Statistic2.Dashboard,
    url: '/Dashboard',
    params: {
        reloadData: null,
    },
    component: Statistic2DashboardComponent,
    resolve: {
        reloadData: [FiStateService, Transition, dashBoardState_reloadData],
    },
};

export function dashBoardState_reloadData(fiStateService: FiStateService, tr: Transition) {
    return fiStateService.getParams(tr).reloadData;
}

const Statistic2ReportState: Ng2StateDeclaration = {
    name: FiStateNames.Statistic2.Report._name,
    url: '/Reports',
    abstract: true,
    component: FiAbstractStateComponent,
    resolve: {},
};

const Statistic2ReportListState: Ng2StateDeclaration = {
    name: FiStateNames.Statistic2.Report.List,
    url: '/?:sortColumn&:sortDirection&:offset',
    component: Statistic2ReportListComponent,
    reloadOnSearch: false,
    resolve: {},
};

const Statistic2ReportViewState: Ng2StateDeclaration = {
    name: FiStateNames.Statistic2.Report.View,
    url: '/{id:[0-9]+}',
    //component: Statistic2ReportViewComponent,
    views: {
        '@': {
            component: Statistic2ReportViewComponent,
        },
    },
    resolve: {
        reportParameter: [Statistic2Service, FiStateService, Transition, reportViewState_reportParameter],
    },
};

export const Statistic2States: StatesModule = {
    states: [
        Statistic2State,
        Statistic2DashboardState,
        Statistic2ReportState,
        Statistic2ReportListState,
        Statistic2ReportViewState,
    ],
};

export function reportViewState_reportParameter(
    statistic2Service: Statistic2Service,
    fiStateService: FiStateService,
    tr: Transition,
) {
    const reportParameterId = fiStateService.getParams(tr).id;
    return statistic2Service.getReportParameter(reportParameterId);
}

export function registerStatistic2StateRules(stateAccessCheckService: StateAccessCheckService) {
    stateAccessCheckService.registerStateRules([FiStateNames.Statistic2._name], {
        SettingType: [ApplicationSettingsType.Statistics2],
        AccessType: AccessRightType.Read,
    });
    stateAccessCheckService.registerStateRules([FiStateNames.Statistic2.Dashboard], {
        SettingType: [ApplicationSettingsType.Statistics2],
        AccessType: AccessRightType.Read,
    });
    stateAccessCheckService.registerStateRules([FiStateNames.Statistic2.Report.List], {
        SettingType: [ApplicationSettingsType.Statistics2],
        AccessType: AccessRightType.Read,
    });
}
